function getBase64ImgSrc(img?: string) {
    return img ? `data:image/jpeg;base64, ${img}` : "";
}

export const Images = { getBase64ImgSrc };
